import { render } from "./MenuLinkGrid.vue?vue&type=template&id=886074d2"
import script from "./MenuLinkGrid.vue?vue&type=script&lang=js"
export * from "./MenuLinkGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__